// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3pRLY","fileBtn":"File_fileBtn__3ome3","closeBtn":"File_closeBtn__1yIXr","fileSelected":"File_fileSelected__SrTh-","disabled":"File_disabled__2UCDY"};